module.exports = __webpack_public_path__ + "img/order.665dcad1.svg";